import { useRouter } from "next/router";
import type { FunctionComponent, ReactNode } from "react";
import { graphql, useFragment } from "react-relay";
import "swiper/css";
import "swiper/css/navigation";

import { cleanUpLabel } from "scmp-app/components/entity-oneline-menu/helper";
import {
  Container,
  MenuItem,
  StyledEntityLink,
} from "scmp-app/components/entity-oneline-menu/styles";
import type { entityOnelineMenuLiteQueueItemsEdge$key } from "scmp-app/queries/__generated__/entityOnelineMenuLiteQueueItemsEdge.graphql";

import { StyledMenuBar, StyledMenuItem } from "./styles";

type Props = {
  className?: string;
  extraItem?: ReactNode;
  onClick?: (itemLabel: string) => void;
  reference: entityOnelineMenuLiteQueueItemsEdge$key;
};

export const EntityOnelineMenuLite: FunctionComponent<Props> = ({
  className,
  extraItem,
  onClick,
  reference,
}) => {
  const { query } = useRouter();
  const items = useFragment(
    graphql`
      fragment entityOnelineMenuLiteQueueItemsEdge on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Topic {
            name
            urlAlias
          }
          ... on Section {
            name
            urlAlias
            urlRedirect {
              toUrl
            }
          }
          ...entityLink
        }
      }
    `,
    reference,
  );

  return (
    <Container className={className}>
      <StyledMenuBar>
        {extraItem && <StyledMenuItem>{extraItem}</StyledMenuItem>}
        {items.map(({ node }, index) => {
          const url = node.urlRedirect?.toUrl ?? node.urlAlias;
          return (
            <StyledMenuItem key={index}>
              <StyledEntityLink
                key={index}
                onClick={() => {
                  onClick?.(cleanUpLabel(node.name));
                }}
                reference={node}
              >
                <MenuItem data-active={query.asPath === url}>{cleanUpLabel(node.name)}</MenuItem>
              </StyledEntityLink>
            </StyledMenuItem>
          );
        })}
      </StyledMenuBar>
    </Container>
  );
};

EntityOnelineMenuLite.displayName = "EntityOnelineMenuLite";
